export default __webpack_public_path__ + "static/media/pause-button@3x.579d9303.png";